var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { consumerTheme } from 'syf-component-library/defaultTheme';
var _a = consumerTheme.meter, gradientStart = _a.gradientStart, gradientEnd = _a.gradientEnd, valueTextColor = _a.valueTextColor;
export var colors = {
    androidGreen: '#B8D037',
    antiFlash: '#F0F3F5',
    arsenic: '#3B3C43',
    auburn: '#9E2A20',
    auroMetalSaurus: '#6B7280',
    beer: '#F9921C',
    black: '#333333',
    blue: '#58a7af',
    brightGray: '#EFEFEF',
    cadetGrey: '#9CA3AF',
    cardinal: '#C4113C',
    charcoal: '#374151',
    cyanBlue: '#34657f',
    darkBlack: '#162B36',
    darkBlue: '#3c777c',
    darkGrey: '#4C4C4C',
    darkSlateGray: '#244759',
    error: '#C63527',
    gray: '#f3f4f6',
    green: '#3e8529',
    grey: '#94969a',
    independence: '#4B5563',
    info: '#0072AD',
    lavenderBlush: '#FCF4F3',
    lightBlack: '#090A09',
    lightBlue: '#e2e7ec',
    lighterBlue: '#0472ae',
    lighterGrey: '#D8D8D8',
    lightestGrey: '#F6F6F6',
    lightGrey: '#E0E0E0',
    lightSilver: '#D1D5DB',
    lightestSilver: '#B1B1B1',
    mediumBlue: '#F0F3F5',
    mediumBlack: '#232323',
    mediumCandyAppleRed: '#EB0A2B',
    mediumGrey: '#F8F8F8',
    mughalGreen: '#2B5C1D',
    navyBlue: '#274e61',
    nyanza: '#E7F6E3',
    orange: '#d76b00',
    quickSilver: '#A3A4A6',
    rackley: '#6194AA',
    silver: '#767676',
    success: '#3E8529',
    text: '#000000',
    warning: '#FEB600',
    white: '#FFFFFF',
    yaleBlue: '#1151A1',
    yellow: '#fbc600',
    slateGray: '#6A6B73'
};
var components = {
    body: {
        background: '#f6f6f6',
        text: '#333333'
    },
    button: {
        background: '#34657f',
        primary: {
            text: '#FFFFFF',
            hover: '#0072ad'
        },
        secondary: {
            text: '#34657f',
            hover: '#ebf0f2'
        }
    },
    certificate: {
        certificateNumber: '#6B7280',
        certificateValue: '#3B3C43',
        expiredTagBackground: '#6B7280',
        headerBackground: '#E5E7EB',
        redeemText: '#374151'
    },
    chip: {
        hover: '#f0f3f5',
        text: '#333333'
    },
    icon: '#34657f',
    link: '#34657f',
    footer: {
        background: '#FFFFFF',
        text: '#333333',
        link: '#35657f'
    },
    checkbox: {
        background: '#34657f',
        font: '#FFFFFF'
    },
    navigation: {
        activeTabText: '#34657F',
        activeTabBorder: '#34657F'
    },
    systemNavigation: {
        background: '#ffffff'
    },
    modal: {
        background: '#ffffff',
        headerBackground: '#f6f6f6'
    },
    hoverBackground: '#f0f3f5',
    datepicker: {
        legend: {
            selectedDate: {
                fill: '#34657f',
                border: '#34657f',
                text: '#ffffff'
            },
            dueDate: {
                fill: '#ffffff',
                border: '#000000',
                text: '#000000'
            },
            lateFeeDate: {
                fill: '#757575',
                border: '#757575',
                text: '#ffffff'
            }
        }
    },
    field: {
        icon: '#34657f',
        focus: '#34657f',
        label: '#34657f'
    },
    tooltip: {
        backgroundColor: '#FFFFFF'
    },
    meter: {
        valueTextColor: valueTextColor,
        gradientStart: gradientStart,
        gradientEnd: gradientEnd
    }
};
var theme = __assign(__assign({}, components), colors);
export default theme;
